/*----- Core -----*/
import React, { useEffect, useState } from 'react'
import { connect } 										from "react-redux"

/*----- Styles -----*/
import Styles from './Styles'

/*----- Utils -----*/
import stringTitleCase from '../../../../utils/StringTitleCase'

/*----- Constants-----*/
import { UPDATE } from '../../../../modules/app/Constants'

/*----- Ant design -----*/
import { Row, Col, Pagination } from 'antd';

/*----- Components -----*/
import SectionContainer       from '../../../../components/commons/SectionContainer'
import Spinner 						    from '../../../../components/commons/Spinner'
import DashboardProducerItem  from '../../../../components/dashboard/DashboardProducerItem'
import PageTitle 							from '../../../../components/text/PageTitle'
import SearchInput 				   	from '../../../../components/search/SearchInput'

/*----- Selectors -----*/
import { listIsloadingSelector, listSelector, loadCompletedSelector } from './Selectors.js'

/*----- Actions  -----*/
import { getProducers, redirect } from './Actions'

function Producers({ 
	getProducers,
	listIsLoading, 
	producersData, 
	match,
	redirect, 
	loadCompleted
}) {

	const INITIAL_PAGINATOR       			    	= { minValue: 0, maxValue: 10}
	const [searchResults, setSearchResults ]	= useState(null)

	const NUEM_EACH_PAGE 	 = 10
	const [page, setPage]  = useState(INITIAL_PAGINATOR)

	useEffect(() => {
		if (!loadCompleted) {
			getProducers()
		}
	},[getProducers,loadCompleted])

	const handlePageChange = (value) => {
		setPage({
			minValue: (value - 1) * NUEM_EACH_PAGE,
			maxValue: value * NUEM_EACH_PAGE
		})
	}

	const onSearchChange = (e) => {
		let value = e.target.value
		if (value.length >=3) {
			const results = producersData.list.filter((e)=>{
				return  e.lastname.includes(stringTitleCase(value)) 
			})
			setSearchResults(results)
		} else {
			setSearchResults(null)
		}
	}
	
	var renderProducerList = () => {
		if (producersData === null || listIsLoading ) {
			return (
				<Styles>
					<div className="spinner-container">
						<Spinner/>
					</div>
				</Styles>
			)
		}
		else if (searchResults) {
			return (
				<>
					{
						searchResults.map((p, i)=>{
							let { name, lastname, mat_number, id } = p
							return (
								<DashboardProducerItem
									key       				= { id }
									i         				= { i + 1 }
									id        				= { id }
									name 		  				= { name }
									lastname 		  		= { lastname }
									mat_number 		  	= { mat_number }
									invert    				= { i % 2 }
									redirectToUpdate 	= { () => redirect( `${match.url}/${id}/${UPDATE}`) }
								/>
							)
						})
					}
					<div className="paginator-container">
						<Pagination 
							defaultCurrent	= {1}
							defaultPageSize = {NUEM_EACH_PAGE}
							onChange			  = {(value)=>handlePageChange(value)}
							total						= {producersData.itemsSize}
							showSizeChanger = {false}
							responsive      
						/>
					</div>
				</>
			)
		}
		return (
			<>
				{
					producersData.list
					.slice(page.minValue, page.maxValue)
					.map((p, i)=>{
						let { name, lastname, mat_number, id } = p
						return (
							<DashboardProducerItem
								key       				= { id }
								i         				= { i + 1 }
								id        				= { id }
								name 		  				= { name }
								lastname 		  		= { lastname }
								mat_number 		  	= { mat_number }
								invert    				= { i % 2 }
								redirectToUpdate 	= { () => redirect( `${match.url}/${id}/${UPDATE}`) }
							/>
						)
					})
				}
				<div className="paginator-container">
					<Pagination 
						defaultCurrent	= {1}
						defaultPageSize = {NUEM_EACH_PAGE}
						onChange			  = {(value)=>handlePageChange(value)}
						total						= {producersData.itemsSize}
						showSizeChanger = {false}
						responsive      
					/>
				</div>
			</>
		)
	}


	return (
		<Styles>
			<SectionContainer>

					<Row style={{marginBottom: 32}}>
						<SearchInput onChange={onSearchChange} noRender data={searchResults} />
					</Row>

					<Row>
						<Col xs={24}>
							<PageTitle content="Productores" />
						</Col>
					</Row>

					<Row>
						<Col xs={24}>
							{ renderProducerList() }
						</Col>
					</Row>
				
			</SectionContainer>
		</Styles>
	)
}

const mapStateToProps = (state) => {
	return {
		listIsLoading:      listIsloadingSelector(state),
		producersData:			listSelector(state),
		loadCompleted:      loadCompletedSelector(state),
		route:              state.router
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
		getProducers:   () => getProducers(dispatch),
		redirect:       (params) => redirect(dispatch, params)
	}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Producers)
